import { Trophy, Lightning, MoonStars, Barbell, MapPin, Flag } from "@phosphor-icons/react";

const recColor = (v) => (v == null ? "#8b93a7" : v >= 67 ? "#00e676" : v >= 34 ? "#ffea00" : "#ff3b30");

export const DigestCard = ({ digest }) => {
  const d = digest;
  if (!d) return null;
  return (
    <div className="w-full" data-testid="digest-card">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-amber-400/30 to-primary/30 border border-amber-300/30 flex items-center justify-center shrink-0">
          <Trophy size={15} weight="fill" className="text-amber-300" />
        </div>
        <div>
          <div className="text-sm font-heading font-bold leading-tight">Итоги недели</div>
          <div className="text-[10px] text-muted-foreground num">{d.week_label}</div>
        </div>
      </div>

      {d.hero && (
        <div className="rounded-xl px-3 py-2.5 mb-2 border border-amber-300/25 bg-gradient-to-r from-amber-400/[0.12] to-transparent" data-testid="digest-hero">
          <div className="text-xs font-bold flex items-center gap-1.5">🏆 Герой недели — {d.hero.name}</div>
          <div className="text-[10px] text-muted-foreground mt-0.5">{d.hero.reason}</div>
        </div>
      )}

      <div className="space-y-1.5">
        {d.members.map((m) => (
          <div key={m.id} className="rounded-lg bg-white/[0.04] border border-white/[0.07] px-2.5 py-2" data-testid={`digest-member-${m.id}`}>
            <div className="text-[11px] font-semibold mb-1">{m.name}</div>
            <div className="flex flex-wrap gap-x-3 gap-y-1 text-[10px] text-muted-foreground">
              <span className="flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: recColor(m.recovery) }} />
                восст. <b className="num text-foreground" style={{ color: recColor(m.recovery) }}>{m.recovery != null ? `${m.recovery}%` : "—"}</b>
              </span>
              <span className="flex items-center gap-1"><MoonStars size={11} className="text-[#a970ff]" />сон <b className="num text-foreground">{m.sleep_h != null ? `${m.sleep_h} ч` : "—"}</b></span>
              <span className="flex items-center gap-1"><Lightning size={11} className="text-[#ffea00]" />нагрузка <b className="num text-foreground">{m.strain != null ? m.strain : "—"}</b></span>
              <span className="flex items-center gap-1"><Barbell size={11} className="text-[#4dabf5]" /><b className="num text-foreground">{m.workouts}</b> трен.</span>
              {m.gps_km > 0 && <span className="flex items-center gap-1"><MapPin size={11} className="text-[#ff9100]" /><b className="num text-foreground">{m.gps_km}</b> км</span>}
            </div>
          </div>
        ))}
      </div>

      {(d.totals.workouts > 0 || d.totals.gps_km > 0) && (
        <div className="text-[10px] text-muted-foreground mt-2">
          Всей семьёй: <b className="num text-foreground">{d.totals.workouts}</b> тренировок{d.totals.gps_km > 0 && <> · <b className="num text-foreground">{d.totals.gps_km} км</b> по GPS</>}
        </div>
      )}

      {d.challenges?.length > 0 && (
        <div className="mt-2 space-y-1" data-testid="digest-challenges">
          {d.challenges.map((c, i) => (
            <div key={i} className="flex items-center gap-1.5 text-[10px]">
              <Flag size={11} weight="fill" className="text-[#00e676] shrink-0" />
              <span className="truncate text-muted-foreground">{c.title}</span>
              <b className="num shrink-0 ml-auto text-foreground">{c.streak}/{c.days_needed}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
